module.exports = __webpack_public_path__ + "img/aniImg5.a1e113cc.png";